export interface SvgProps {
	name: string;
	className?: string;
}

export function Svg({ name, className }: SvgProps) {
	return (
		<svg className={`svg${className ? ` ${className}` : ''}`}>
			<use xlinkHref={`/__spritemap#sprite-${name}`}></use>
		</svg>
	);
}
